import React from 'react'
import Box from "@mui/material/Box";

import {ListDealsPageHeader} from "./ListDealsPageHeader";
import {ListDealsList} from "./ListDealsList";

import './ListDealsPage.scss'
import {useFilterUrlSync} from "./useFilterUrlSync";
import {useThemeStore} from "../../stores/themeStore";

export const ListDealsPage = () => {
    const theme = useThemeStore((state) => state.theme)

    // Two-way bind every filter in the store to the URL search params, so
    // refresh + shared links work and filters survive navigation.
    useFilterUrlSync()

    // `data-theme="light"|"dark"` selects the palette block in SCSS — the
    // page bg / panel / text / accent tokens flip in one step. We no
    // longer set `background` inline because the SCSS reads it from the
    // token, which is what makes the swap reactive. Page padding also lives in
    // SCSS now (shared 48px/30px inset with CalculatePage).
    return (
        <Box
            id={"ListDealsPage"}
            data-theme={theme}
        >
            <ListDealsPageHeader/>
            <ListDealsList />
        </Box>
    )
}
